import { CORE, gateway } from '../../api';

export function buscarStatusAcordoSeguroHabilitar() {
  return gateway.get(`${CORE}/acordo-seguro/status-habilitado`);
}
